var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "my-2" }, [
      _c("label", { attrs: { for: "file" } }, [_vm._v(_vm._s(_vm.label))]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "v-input" },
      [
        _vm.$slots.prepend
          ? _c(
              "div",
              { staticClass: "v-input__prepend-outer" },
              [_vm._t("prepend")],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c("FilePond", {
          ref: "multiUpload",
          staticClass: "v-input__control",
          style: _vm.cssVars,
          attrs: {
            id: "multi-files-upload",
            name: "file",
            "label-idle": _vm.idleQuote,
            "accepted-file-types": _vm.accept,
            "max-file-size": _vm.maxFileSize,
            "max-files": _vm.maxFiles,
            server: _vm.server,
            files: _vm.file,
            "instant-upload": _vm.instantUpload,
            "item-insert-location": _vm.itemInsertLocation,
            "file-validate-type-label-expected-types-map": _vm.typeWarnMsg,
            "style-item-panel-aspect-ratio": _vm.itemAspectRatio,
            "allow-browse": _vm.enableBrowse,
            "allow-remove": _vm.enableRemove,
            "allow-reorder": true,
            credits: "false",
            "allow-multiple": "",
            "drop-validation": "",
          },
          on: {
            processfile: _vm.fileUpload,
            removefile: _vm.fileRemove,
            activatefile: _vm.fileDownload,
            reorderfiles: _vm.fileReorder,
            updatefiles: _vm.emitOutput,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }